import { apiCall } from './base';

export const fetchAvailabilities = (description = '') =>
  apiCall(`/availabilities`, { method: 'GET', params: { description } });